import React from 'react';
import { Frame, Icon, SageClassnames, SageTokens } from '@kajabi/sage-react';
import PropTypes from 'prop-types';

import { MockItem } from './MockItem';

export const Coaching = ({ breakpoints, hideOrExpandSection }) => {
  return (
    <Frame gap={Frame.GAPS.NONE}>
      <Frame
        direction={Frame.DIRECTIONS.HORIZONTAL}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : 'MD']}
      >
        <Frame align={Frame.ALIGNMENTS.CENTER_LEFT} style={{ height: '100%' }}>
          <MockItem
            color={SageTokens.COLOR_PALETTE.RED_200}
            height={12}
            width={87}
          />
        </Frame>
        <Frame
          align={Frame.ALIGNMENTS.CENTER_RIGHT}
          direction={
            Frame.DIRECTIONS[breakpoints.sm ? 'VERTICAL' : 'HORIZONTAL']
          }
          gap={Frame.GAPS[breakpoints.sm ? '2XS' : 'MD']}
        >
          {Array(breakpoints.sm ? 3 : 5)
            .fill()
            .map((_, index) => (
              <MockItem
                color={SageTokens.COLOR_PALETTE.RED_200}
                height={8}
                key={`coaching-page-header-${index}`}
              />
            ))}
        </Frame>
      </Frame>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_CENTER}
        background="#FEDFDC"
        className={hideOrExpandSection(1)}
        padding={Frame.PADDINGS[breakpoints.sm ? 'MD' : 'XL']}
      >
        <Frame
          align={Frame.ALIGNMENTS[breakpoints.sm ? 'CENTER_CENTER' : 'BOTTOM_LEFT']}
          direction={Frame.DIRECTIONS[breakpoints.sm ? 'VERTICAL' : 'HORIZONTAL']}
          style={{ maxWidth: breakpoints.sm ? undefined : 636 }}
        >
          <Frame align={Frame.ALIGNMENTS[breakpoints.sm ? 'CENTER_CENTER' : 'BOTTOM_LEFT']}>
            <MockItem
              color="#FC8278"
              height={12}
              width="25%"
            />
            <MockItem
              color={SageTokens.COLOR_PALETTE.RED_200}
              height={12}
              width="100%"
            />
          </Frame>
          <Frame
            align={Frame.ALIGNMENTS[breakpoints.sm ? 'CENTER_CENTER' : 'BOTTOM_LEFT']}
            width={Frame.WIDTHS.HUG}
          >
            <div
              style={{
                backgroundColor: SageTokens.COLOR_PALETTE.RED_200,
                borderRadius: 8,
                height: 36,
                width: 100,
              }}
            >
              &nbsp;
            </div>
          </Frame>
        </Frame>
      </Frame>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_CENTER}
        className={hideOrExpandSection(1)}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : 'XL']}
      >
        {
          Array(breakpoints.sm ? 1 : 2)
            .fill()
            .map((_, section) => (
              <Frame
                border={Frame.BORDERS.DEFAULT}
                borderRadius={Frame.BORDER_RADII.MD}
                key={`coaching-page-section-${section}`}
                padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : 'MD']}
                style={{ maxWidth: breakpoints.sm ? undefined : 616 }}
              >
                <MockItem
                  color="#FC8278"
                  height={12}
                  width={124}
                />
                {Array(4)
                  .fill()
                  .map((_, row) => (
                    <Frame
                      align={Frame.ALIGNMENTS.CENTER_CENTER}
                      border={Frame.BORDERS.DEFAULT}
                      borderRadius={Frame.BORDER_RADII.MD}
                      className={hideOrExpandSection(2)}
                      direction={Frame.DIRECTIONS.HORIZONTAL}
                      key={`coaching-page-section-${section}-row-${row}`}
                      padding={Frame.PADDINGS.SM}
                      width={Frame.WIDTHS.FILL}
                    >
                      <Frame width={Frame.WIDTHS.HUG}>
                        <Icon
                          color={Icon.COLORS.RED_200}
                          icon={Icon.ICONS.CALENDAR_SIMPLE}
                        />
                      </Frame>
                      <Frame
                        align={Frame.ALIGNMENTS.CENTER_SPREAD}
                        direction={Frame.DIRECTIONS.HORIZONTAL}
                        width={Frame.WIDTHS.FILL}
                      >
                        <MockItem
                          color={SageTokens.COLOR_PALETTE.RED_200}
                          height={12}
                          width="26%"
                        />
                        <MockItem
                          color="#FEDFDC"
                          height={8}
                          width="37%"
                        />
                      </Frame>
                    </Frame>
                  ))}
              </Frame>
            ))
        }
      </Frame>
    </Frame>
  );
};

Coaching.propTypes = {
  breakpoints: PropTypes.shape({}).isRequired,
  hideOrExpandSection: PropTypes.func.isRequired,
};
